import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CommunicationService } from "src/app/services/communication.service";

@Component({
  selector: "app-all-requests",
  templateUrl: "./all-requests.component.html",
  styleUrls: ["./all-requests.component.css"]
})
export class AllRequestsComponent implements OnInit {
  // routeToChange: string = 'requestItems';
  public itemsRequests: any[] = [];
  public customersRequests: any[] = [];
  constructor(
    private router: Router,
    private commservice: CommunicationService
  ) {}

  ngOnInit(): void {
    this.fetchAllMerchantsRequests();
  }

  // navigates between request and customers
  navigate(event: Event) {
    const val = (event.srcElement as HTMLSelectElement).value;
    console.log(val);
    this.router.navigate([`/requests/${val}`]);
  }

  fetchAllMerchantsRequests() {
    this.commservice
      .getMerchantRequests()
      .subscribe(val => console.log(val), err => console.log(err));
  }
}
